module.exports = __webpack_public_path__ + "img/1.026cbc90.jpg";